import { css } from 'styled-components';
import { breakpoints } from '../../breakpoints';
import { cssfonts } from '../cssfonts';

const common = css`
  font-size: 1.75rem; /* 28px */
  line-height: 1.3; /* 28/36 */

  @media (min-width: ${breakpoints.desktop}) {
    font-size: 2.25rem; /* 36px */
    line-height: 1.35; /* 36/48 */
  }
`;

export const h4 = {
  extrabold: css`
    ${cssfonts.exbold}
    ${common}
  `,
  bold: css`
    ${cssfonts.bold}
    ${common}
  `,
  regular: css`
    ${cssfonts.regular}
    ${common}
  `,
  light: css`
    ${cssfonts.light}
    ${common}
  `,
  common: css`
    ${common}
  `,
} as const;

